/**
 * Strings específicas de componentes
 *
 * Convenções:
 * - Keys em SCREAMING_SNAKE_CASE (inglês)
 * - Valores em português
 * - Organizadas por componente
 */
export var COMPONENT_STRINGS = {
    FILE_UPLOAD: {
        SELECT_BUTTON: "Selecionar",
        DROP_ZONE: "Arraste arquivos ou clique para selecionar",
        DROP_ZONE_ACTIVE: "Solte os arquivos aqui",
        MAX_SIZE: "Tamanho máximo",
        ALLOWED_TYPES: "Tipos permitidos",
        FILE_TOO_LARGE: "Arquivo muito grande",
        INVALID_FILE_TYPE: "Tipo de arquivo não permitido",
        UPLOAD_SUCCESS: "Arquivo enviado com sucesso",
        UPLOAD_ERROR: "Erro ao enviar arquivo",
        MAX_FILES_ERROR: function (max) {
            return "Voc\u00EA s\u00F3 pode enviar at\u00E9 ".concat(max, " arquivos.");
        },
        REMOVE_SUCCESS: "Arquivo removido com sucesso!",
    },
    ERROR_MODAL: {
        DEFAULT_TITLE: "Erro",
        CANCEL: "Cancelar",
        CLOSE: "Fechar",
        CONFIRM: "Confirmar",
    },
    PAGINATION: {
        PREVIOUS: "Anterior",
        NEXT: "Próximo",
        FIRST: "Primeira",
        LAST: "Última",
        PAGE: "Página",
        OF: "de",
        SHOWING: "Mostrando",
        RESULTS: "resultados",
    },
    BREADCRUMB: {
        HOME: "Início",
        SEPARATOR: "/",
        DETAILS: "Detalhes",
    },
    FOOTER: {
        COPYRIGHT: "© 2024 Todos os direitos reservados",
    },
    GOOGLE_MAP: {
        LOADING: "Carregando mapa...",
        ERROR_LOADING: "Erro ao carregar o mapa",
        NO_RESULTS: "Nenhum resultado encontrado",
        YOUR_POSITION: "Sua posição",
    },
    PLACE_AUTOCOMPLETE: {
        PLACEHOLDER: "Pesquise o endereço",
        NO_RESULTS: "Nenhum resultado encontrado",
        SEARCHING: "Buscando...",
    },
    SELECT_INPUT: {
        PLACEHOLDER: "Selecione uma opção",
        NO_OPTIONS: "Nenhuma opção disponível",
        SEARCH_PLACEHOLDER: "Buscar...",
        SELECT_PLACEHOLDER: "Selecione...",
    },
    TEXT_FIELD: {
        SHOW_PASSWORD: "Mostrar senha",
        HIDE_PASSWORD: "Ocultar senha",
    },
    HEADER: {
        TITLE: "ReclamaProcon",
        SUBTITLE: "Secretaria de Justiça, Direitos Humanos e prevenção a violência",
        LINKS: {
            HOME: "Início",
            PROTOCOL: "Acompanhar Protocolo",
            ABOUT: "Sobre",
            CONTACT: "Fale conosco",
            TECH_ACCESS: "Acesso Técnico",
        },
        BUTTONS: {
            ENTER: "Entrar",
            EXIT: "Sair",
        },
    },
    SECONDARY_FOOTER: {
        LINKS: {
            PROTOCOL: "Acompanhar Protocolo",
            ABOUT: "Sobre o Procon-PE",
            CONTACT: "Fale conosco",
            OMBUDSMAN: "Ouvidoria",
            TRANSPARENCY: "Transparência",
        },
    },
    COMPLAINT: {
        BREADCRUMB: "Denúncia",
        TITLE: "O que é uma Denúncia?",
        DESCRIPTION: "A denúncia é utilizada para reportar irregularidades que afetam consumidores em geral, como produtos vencidos, preços abusivos ou práticas enganosas. Ela serve para acionar a fiscalização do Procon-PE.",
        WHEN_TO_REPORT: {
            TITLE: "Quando fazer uma denúncia?",
            ITEMS: [
                "Produtos vencidos ou impróprios para consumo",
                "Preços abusivos ou práticas enganosas",
                "Irregularidades que afetam consumidores em geral",
                "Situações que requerem fiscalização",
            ],
        },
        HOW_TO_REPORT_TITLE: "Como você deseja fazer sua denúncia?",
        HOW_TO_REPORT_SUBTITLE: "Selecione uma das opções a direita, e faça sua denúncia.",
        CARDS: {
            ANONYMOUS: {
                TITLE: "Denúncia Anônima",
                SUBTITLE: "Sua identidade será mantida em sigilo",
                FEATURES: [
                    "Não requer cadastro ou login",
                    "Identidade protegida",
                    "Acompanhamento por protocolo",
                ],
                BUTTON: "Fazer Denúncia Anônima",
            },
            IDENTIFIED: {
                TITLE: "Denúncia Identificada",
                SUBTITLE: "Faça login para identificar sua denúncia",
                FEATURES: [
                    "Requer login no sistema",
                    'Acompanhamento no painel "Meus casos"',
                    "Possibilidade de contato direto",
                ],
                BUTTON: "Fazer login para continuar",
            },
        },
    },
    ANONYMOUS_COMPLAINT_FORM: {
        TITLE: "Formulário de denúncia",
        SUBTITLE: "Relate irregularidades de forma anônima e ajude a fiscalizar o mercado.",
        SECTION_TITLE: "Denúncia Anônima",
        SECTION_DESCRIPTION: "Preencha os campos abaixo com o máximo de detalhes possível. Sua identidade será mantida em sigilo.",
        FIELDS: {
            IRREGULARITY_TYPE: {
                LABEL: "Tipo de Irregularidade",
                PLACEHOLDER: "Selecione uma opção",
                OPTIONS: [
                    { label: "Preço abusivo", value: "preco_abusivo" },
                    { label: "Produto vencido", value: "produto_vencido" },
                    { label: "Propaganda enganosa", value: "propaganda_enganosa" },
                    { label: "Outros", value: "outros" },
                ],
            },
            COMPANY_NAME: {
                LABEL: "Nome da empresa ou estabelecimento",
                PLACEHOLDER: "Ex: Supermercado ABC",
            },
            LOCATION: {
                LABEL: "Local (Endereço ou Bairro)",
                PLACEHOLDER: "Ex: Supermercado ABC",
            },
            DESCRIPTION: {
                LABEL: "Descrição da Irregularidade",
                PLACEHOLDER: "Descreva detalhadamente a irregularidade observada. Inclua informações como data, horário, produtos envolvidos, valores, etc.",
                HINT: function (count) { return "M\u00EDnimo de 20 caracteres (".concat(count, "/20)"); },
            },
            ATTACHMENTS: {
                LABEL: "Anexar Arquivos (Opcional)",
                NOTE: "Formatos aceitos: JPG, PNG, PDF. Tamanho máximo: 5MB por arquivo. Máximo: 5 arquivos.",
            },
        },
        ALERT: "Esta denúncia é anônima. Após o envio, você receberá um número de protocolo para acompanhar o andamento. Guarde este número com segurança.",
        BUTTONS: {
            CANCEL: "Cancelar",
            SUBMIT: "Enviar Denúncia",
        },
    },
    IDENTIFIED_COMPLAINT_FORM: {
        SECTION_TITLE: "Detalhes da irregularidade",
        SECTION_DESCRIPTION: "Forneça o máximo de informações sobre o estabelecimento e o problema observado.",
        FIELDS: {
            IRREGULARITY_TYPE: {
                LABEL: "Tipo de Irregularidade",
                PLACEHOLDER: "Selecione o tipo",
                OPTIONS: [
                    { label: "Falta de preços", value: "falta_preços" },
                    { label: "Produto vencido", value: "produto_vencido" },
                    { label: "Propaganda enganosa", value: "propaganda_enganosa" },
                    { label: "Outros", value: "outros" },
                ],
            },
            COMPANY_NAME: {
                LABEL: "Nome da empresa ou estabelecimento",
                PLACEHOLDER: "Ex: Supermercado ABC",
            },
            LOCATION: {
                LABEL: "Local (Endereço ou Bairro)",
                PLACEHOLDER: "Ex: Supermercado ABC",
            },
            DESCRIPTION: {
                LABEL: "Descrição da Irregularidade",
                PLACEHOLDER: "Descreva detalhadamente a irregularidade observada. Inclua informações como data, horário, produtos envolvidos, valores, etc.",
                HINT: function (count) { return "M\u00EDnimo de 20 caracteres (".concat(count, "/20)"); },
            },
            ATTACHMENTS: {
                LABEL: "Anexar Arquivos (Opcional)",
                NOTE: "Formatos aceitos: JPG, PNG, PDF. Tamanho máximo: 5MB por arquivo. Máximo: 5 arquivos.",
            },
        },
        ALERT: "Sua identidade será vinculada a esta denúncia. Após o envio, você poderá acompanhá-la em sua área logada ou através do número de protocolo.",
        BUTTONS: {
            CANCEL: "Cancelar",
            SUBMIT: "Enviar Denúncia",
        },
    },
    COMPLAINT_SUCCESS: {
        TITLE: "Denúncia enviada com sucesso!",
        SUBTITLE: "Sua denúncia foi registrada e será analisada pela nossa equipe.",
        PROTOCOL_LABEL: "Número do Protocolo",
        IMPORTANT_WARNING: {
            TITLE: "Importante",
            TEXT: "Guarde este número de protocolo com segurança. Você precisará dele para acompanhar o andamento da sua denúncia.",
        },
        INFO_WARNING: "Você pode consultar o status da sua denúncia a qualquer momento usando o número do protocolo na página de acompanhamento.",
        NEXT_STEPS: {
            TITLE: "Próximos Passos:",
            ITEMS: [
                "Sua denúncia será analisada pela equipe técnica do Procon-PE",
                "O prazo médio de análise é de 5 a 10 dias úteis",
                "Você pode acompanhar o status usando o número do protocolo",
                "Caso necessário, nossa equipe poderá realizar fiscalização no local",
            ],
        },
        BUTTONS: {
            TRACK: "Acompanhar Denúncia",
            PRINT: "Imprimir",
        },
    },
    HOME_PAGE: {
        TITLE: "Página Inicial",
        WELCOME_TEXT: "Bem-vindo ao template frontend. Utilize este espaço para construir sua aplicação utilizando as melhores práticas e componentes disponíveis.",
    },
    DASHBOARD: {
        TITLE: "Painel de Fiscalização",
        SUBTITLE: "Gerencie e acompanhe todas as denúncias recebidas abaixo.",
        INSTRUCTION: 'Para realizar triagem e mudar status de uma denúncia, clique em "Analisar".',
        CARDS: {
            TOTAL: "Total de denúncias",
            RECEIVED: "Recebida",
            IN_ANALYSIS: "Em análise",
            INSPECTED: "Fiscalizada",
        },
        SEARCH: {
            PLACEHOLDER: "Protocolo, tipo, local ou denunciante...",
            FILTER_STATUS: "Filtro por status",
        },
        COMPLAINT_CARD: {
            DATA: "Data",
            TYPE: "Tipo",
            NAME: "Nome",
            LOCATION: "Local",
            COMPLAINANT: "Denunciante",
            ATTACHMENTS: function (count) { return "".concat(count, " anexo(s)"); },
            BUTTON_ANALYZE: "Analisar",
        },
    },
    COMPLAINT_ANALYSIS: {
        TITLE: "Análise da Denúncia",
        PROTOCOL: "Protocolo",
        PROTOCOL_NUMBER: "Número do Protocolo:",
        STATUS: "Status Atual",
        LOADING: "Carregando...",
        NOT_FOUND: "Denúncia não encontrada.",
        FORM: {
            INTERNAL_STATUS: "Status Interno",
            PUBLIC_STATUS: "Status Público",
            NOTE: "Observação Interna",
            NOTE_PLACEHOLDER: "Descreva a análise ou o motivo da mudança de status...",
            SUBMIT: "Atualizar Status",
            CANCEL: "Voltar",
        },
        SECTIONS: {
            DETAILS: {
                TITLE: "Detalhes da Denúncia",
                IRREGULARITY_TYPE: "Tipo de Irregularidade",
                DESCRIPTION: "Descrição",
                LOCATION: "Local da Ocorrência",
                REGISTRATION_DATE: "Data de Registro",
            },
            COMPLAINANT: {
                TITLE: "Dados do Denunciante",
                FULL_NAME: "Nome Completo",
                ANONYMOUS: "Anônimo",
                DOCUMENT: "CPF",
                EMAIL: "E-mail",
                PHONE: "Telefone",
            },
            SUPPLIER: {
                TITLE: "Dados do Estabelecimento",
                NAME: "Nome",
                CNPJ: "CNPJ",
                ADDRESS: "Endereço",
                NO_ADDRESS: "Endereço não informado",
            },
            ATTACHMENTS: {
                TITLE: "Anexos",
                EMPTY: "Nenhum anexo.",
                DOWNLOAD: "Baixar",
            },
            HISTORY: {
                TITLE: "Histórico",
            },
            INTERNAL_NOTES: {
                TITLE: "Notas Internas",
                VISIBILITY_MSG: "Visível apenas para a equipe da fiscalização",
                LOADING: "Carregando notas...",
                EMPTY: "Nenhuma nota interna registrada.",
                USER_LABEL: "Usuário",
                ADD_NEW: "Adicionar nova nota",
                PLACEHOLDER: "Escreva suas observações sobre esta denúncia...",
                SAVE: "Salvar nota",
                SAVING: "Salvando...",
                SUCCESS: "Nota interna adicionada com sucesso!",
                ERROR_FETCH: "Erro ao carregar notas internas.",
                ERROR_SAVE: "Erro ao salvar nota interna.",
            },
            PROCESS_STATUS: {
                TITLE: "Status do processo",
                DESCRIPTION: "Selecione o status do processo entre 'Recebido', 'Em análise', 'Fiscalizada' ou 'Arquivada'. Alteração salva no histórico abaixo.",
                CURRENT_STATUS: "Status atual",
                JUSTIFICATION_LABEL: "Justificativa* (Obrigatório)",
                JUSTIFICATION_PLACEHOLDER: "Justifique a mudança de status...",
                SAVE: "Salvar alteração",
                SAVING: "Salvando...",
            },
        },
    },
    CITIZEN_LOGIN: {
        TITLE: "Login do Cidadão",
        SUBTITLE: "Entre com seu CPF e senha para acompanhar seus processos.",
        CPF_LABEL: "CPF",
        CPF_PLACEHOLDER: "000.000.000-00",
        PASSWORD_LABEL: "Senha",
        PASSWORD_PLACEHOLDER: "••••••••••••",
        SUBMIT_BUTTON: "Entrar",
        FOOTER_LINKS: {
            REGISTER: "Não tem conta? Cadastre-se",
            TECH_ACCESS: "É técnico? Acesso do técnico",
        },
    },
    LOGIN_PAGE: {
        TITLE: "Acesso de Técnicos",
        SUBTITLE: "Entre com suas credenciais para acessar o sistema.",
        WARNING_BOX: "Esta área é restrita a técnicos autorizados do Procon-PE. O acesso não autorizado é proibido e será registrado.",
        EMAIL_LABEL: "E-mail institucional",
        EMAIL_PLACEHOLDER: "seu.email@procon.pe.gov.br",
        EMAIL_HINT: "Use seu e-mail institucional do Procon-PE",
        PASSWORD_LABEL: "Senha",
        PASSWORD_PLACEHOLDER: "••••••••••••",
        SUBMIT_BUTTON: "Entrar",
        FOOTER_LINKS: {
            FIRST_ACCESS: "Primeiro acesso?",
            REGISTER_HERE: "Cadastre-se aqui",
            FORGOT_PASSWORD: "Esqueceu sua senha?",
            RECOVER_ACCESS: "Recuperar acesso",
            NOT_A_TECH: "Não é técnico?",
            CITIZEN_ACCESS: "Acesso do cidadão",
        },
    },
    COMPLAINT_TRACKING: {
        BREADCRUMB: "Acompanhar Protocolo",
        TITLE: "Acompanhamento Público",
        DESCRIPTION: "Consulte o status da sua denúncia de forma transparente e pública. Indique o número do protocolo para acompanhar o andamento.",
        SEARCH_LABEL: "Número do Protocolo",
        SEARCH_PLACEHOLDER: "Ex: BAE-0012345678",
        PROTOCOL_NOT_FOUND: "Protocolo não encontrado.",
        BACK_BUTTON: "Voltar ao início",
        EMPTY_PROTOCOL_WARNING: "Por favor, digite o número do protocolo.",
        ONLY_COMPLAINT_WARNING: "O acompanhamento público funciona apenas para protocolos de denúncia (que começam com DEN). Para reclamações, acesse sua área logada.",
        INFO_BOX: {
            TITLE: "Informações Importantes!",
            ITEMS: [
                "O número de protocolo foi enviado para o e-mail cadastrado no momento da denúncia.",
                "O acompanhamento público permite consultar apenas denúncias. Para reclamações, acesse sua área logada.",
                "As informações são atualizadas em tempo real conforme o andamento do processo.",
                "Em caso de dúvidas, entre em contato através dos nossos canais de atendimento.",
            ],
        },
        HISTORY_DESCRIPTIONS: {
            RECEIVED: "Denúncia recebida e protocolo gerado.",
            ANALYSIS: "Denúncia em análise preliminar pela equipe técnica.",
            IN_PROGRESS: "Fiscalização iniciada. Diligências em andamento.",
            CONCLUDED: "Processo concluído.",
        },
    },
    // ─── Reclamação Pública (cidadão) ────────────────────────────────────────────
    RECLAMATION: {
        BREADCRUMB: "Reclamação",
        TITLE: "O que é uma Reclamação?",
        DESCRIPTION: "A reclamação é utilizada quando você teve um problema específico com um produto ou serviço adquirido e busca uma solução direta com a empresa através da mediação do Procon-PE.",
        WHEN_TO_REPORT: {
            TITLE: "Quando fazer uma reclamação?",
            ITEMS: [
                "Problema específico com produto ou serviço adquirido",
                "Busca solução direta com a empresa",
                "Necessita acompanhar o processo individualmente",
                "Quer mediação oficial entre você e o fornecedor",
            ],
        },
        INFO_BOX: "É necessário estar cadastrado e logado para registrar uma reclamação. Assim, você pode acompanhar o andamento e receber notificações.",
        CARD: {
            TITLE: "Pronto para fazer sua reclamação?",
            LOGGED_IN_SUBTITLE: "Você está logado e pode prosseguir com sua reclamação.",
            LOGGED_OUT_SUBTITLE: "Faça login ou cadastre-se para continuar.",
            LOGGED_IN_BANNER: "Você está logado e pode prosseguir!",
            BUTTON_REGISTER: "Registrar Reclamação",
            BUTTON_LOGIN: "Fazer login",
            BUTTON_REGISTER_ACCOUNT: "Criar conta",
        },
    },
    // ─── Formulário de Reclamação ────────────────────────────────────────────────
    RECLAMATION_FORM: {
        TITLE: "Registrar Reclamação",
        SUBTITLE: "Preencha o formulário abaixo com os detalhes da sua reclamação.",
        CATEGORIES: [
            { label: "Produto com defeito", value: "produto_defeito" },
            { label: "Cobrança indevida", value: "cobrança_indevida" },
            { label: "Serviço não prestado", value: "serviço_nao_prestado" },
            { label: "Propaganda enganosa", value: "propaganda_enganosa" },
            { label: "Descumprimento de contrato", value: "descumprimento_contrato" },
            { label: "Outros", value: "outros" },
        ],
        SECTIONS: {
            COMPANY: {
                TITLE: "Informações da Empresa",
                SUBTITLE: "Dados da empresa relacionada à reclamação",
                CATEGORY_LABEL: "Categoria da Reclamação",
                CATEGORY_PLACEHOLDER: "Selecione uma categoria",
                COMPANY_NAME_LABEL: "Nome da empresa",
                COMPANY_NAME_PLACEHOLDER: "Ex: Loja ABC",
                CNPJ_LABEL: "CNPJ",
                CNPJ_PLACEHOLDER: "00.000.000/0000-00",
                VALUE_LABEL: "Valor Envolvido",
                VALUE_PLACEHOLDER: "R$ 0,00",
            },
            OCCURRENCE: {
                TITLE: "Detalhes do Ocorrido",
                SUBTITLE: "Informações sobre quando e onde ocorreu o problema",
                DATE_LABEL: "Data do ocorrido",
                LOCATION_LABEL: "Local do ocorrido",
                LOCATION_PLACEHOLDER: "Ex: Recife-PE",
                DESCRIPTION_LABEL: "Descrição do problema",
                DESCRIPTION_PLACEHOLDER: "Descreva detalhadamente o problema ocorrido, incluindo datas, valores e circunstâncias relevantes...",
                DESCRIPTION_HINT: function (count) {
                    return "M\u00EDnimo de 50 caracteres (".concat(count, "/50)");
                },
                SOLUTION_LABEL: "O que você espera como solução?",
                SOLUTION_PLACEHOLDER: "Ex: Troca do produto, devolução do valor pago, reparo do serviço...",
                SOLUTION_HINT: function (count) {
                    return "M\u00EDnimo de 50 caracteres (".concat(count, "/50)");
                },
            },
            DOCUMENTS: {
                TITLE: "Documentos e Comprovantes",
                SUBTITLE: "Anexe fotos, notas fiscais ou outros documentos relevantes (opcional)",
                FILE_LABEL: "Anexar Arquivos (Opcional)",
                FILE_NOTE: "Formatos aceitos: JPG, PNG, PDF. Tamanho máximo: 10MB por arquivo. Máximo: 5 arquivos.",
            },
        },
        VALIDATION: {
            CATEGORY_REQUIRED: "Selecione uma categoria.",
            COMPANY_REQUIRED: "Informe o nome da empresa.",
            DATE_REQUIRED: "Selecione a data do ocorrido.",
            DESCRIPTION_MIN: "Descreva o problema com pelo menos 50 caracteres.",
            SOLUTION_MIN: "Descreva a solução esperada com pelo menos 50 caracteres.",
            VALUE_TOO_HIGH: "O valor envolvido não pode exceder R$ 999.999.999.999,99.",
            INVALID_CNPJ: "CNPJ inválido. Verifique os números informados.",
            INVALID_CPF: "CPF inválido. Verifique os números informados.",
        },
        BUTTONS: {
            CANCEL: "Cancelar",
            SUBMIT: "Registrar Reclamação",
            SUBMITTING: "Enviando...",
        },
        TOAST: {
            SUCCESS: "Reclamação registrada com sucesso!",
            ERROR: "Erro ao registrar reclamação. Tente novamente.",
        },
    },
    // ─── Tela de Sucesso da Reclamação ───────────────────────────────────────────
    RECLAMATION_SUCCESS: {
        TITLE: "Reclamação registrada com sucesso!",
        SUBTITLE: "Sua reclamação foi registrada e será encaminhada à empresa.",
        PROTOCOL_LABEL: "Número do Protocolo",
        COPY_TOOLTIP: "Copiar protocolo",
        COPY_SUCCESS: "Protocolo copiado!",
        IMPORTANT: {
            TITLE: "Importante",
            TEXT: 'Guarde este número de protocolo. Você pode acompanhar o andamento da sua reclamação no painel "Minhas reclamações" ou na página de acompanhamento público.',
        },
        NEXT_STEPS: {
            TITLE: "Próximos Passos:",
            ITEMS: [
                "Sua reclamação será analisada pela equipe do Procon-PE",
                "A empresa será notificada e terá prazo para responder",
                "Você receberá atualizações sobre o andamento do processo",
                'Acompanhe o status pelo painel "Minhas reclamações"',
            ],
        },
        BUTTONS: {
            TRACK: "Acompanhar reclamação",
            PRINT: "Imprimir",
        },
    },
    // ─── Detalhes da Reclamação (área admin) ────────────────────────────────────
    RECLAMATION_ANALYSIS: {
        LOADING: "Carregando...",
        NOT_FOUND: "Reclamação não encontrada.",
        PROTOCOL_NUMBER: "Número do Protocolo:",
        COPY_SUCCESS: "Copiado!",
        BACK_BUTTON: "Voltar à fila",
        SECTIONS: {
            DETAILS: {
                TITLE: "Detalhes da Reclamação",
                CATEGORY: "Categoria",
                DESCRIPTION: "Descrição do problema",
                INVOLVED_VALUE: "Valor envolvido",
                EVENT_LOCATION: "Local do evento",
                POSSIBLE_SOLUTION: "Solução proposta pelo consumidor",
                REGISTRATION_DATE: "Data de Registro",
            },
            CONSUMER: {
                TITLE: "Dados do Consumidor",
                FULL_NAME: "Nome Completo",
                RG: "RG",
                CPF: "CPF",
                EMAIL: "E-mail",
                PHONE: "Telefone",
            },
            SUPPLIER: {
                TITLE: "Dados da empresa",
                NAME: "Nome",
                CNPJ: "CNPJ",
                EMAIL: "E-mail",
                PHONE: "Telefone",
            },
            ATTACHMENTS: {
                TITLE: "Anexos",
                EMPTY: "Nenhum anexo.",
                DOWNLOAD_BUTTON: "Baixar",
                DOWNLOAD_ALL: function (count) { return "Baixar todos os anexos (".concat(count, ")"); },
                GENERATE_REPORT: "Gerar relatório",
                DOWNLOAD_ALL_TOAST: "Download de todos os arquivos iniciado.",
                REPORT_TOAST: "Gerando relatório...",
            },
            NOTIFY_SUPPLIER: {
                TITLE: "Notificação ao Fornecedor",
                DESCRIPTION: "Envie um link de acesso seguro para que o fornecedor possa visualizar e responder a esta reclamação.",
                EMAIL_LABEL: "E-mail do Fornecedor",
                EMAIL_PLACEHOLDER: "exemplo@empresa.com.br",
                BUTTON_SEND: "Enviar link de acesso",
                SUCCESS_TOAST: "Link de acesso enviado com sucesso!",
                ERROR_TOAST: "Erro ao enviar link. Verifique o e-mail.",
                COPY_LINK_BUTTON: "Copiar link manualmente",
                COPY_SUCCESS: "Link de resposta copiado!",
            },
            STATUS: {
                TITLE: "Status da reclamação",
                DESCRIPTION: "Selecione o status do processo entre 'Pendente', 'Em análise' ou 'Resolvida'. Alteração salva no histórico abaixo.",
                CURRENT_STATUS: "Status atual",
                SAVE: "Salvar alteração",
                SAVING: "Salvando...",
                OPTIONS: [
                    { label: "Pendente", value: "PENDING_FORMALIZATION" },
                    { label: "Em análise técnica", value: "IN_TECHNICAL_ANALYSIS" },
                    { label: "Aguardando planejamento", value: "AWAITING_PLANNING" },
                    { label: "Inspeção concluída", value: "INSPECTION_COMPLETED" },
                    { label: "Arquivada", value: "ARCHIVED" },
                ],
                SUCCESS_TOAST: "Status atualizado com sucesso!",
                ERROR_TOAST: "Erro ao atualizar status.",
            },
            HISTORY: {
                TITLE: "Histórico",
            },
            TRANSFER_TIP: {
                TEXT: "Use os botões de cópia rápida ao lado de cada campo para transferir dados facilmente ao Proconsumidor.",
            },
        },
    },
    // ─── Resposta do Fornecedor (Magic Link) ────────────────────────────────────
    SUPPLIER_RESPONSE: {
        LOADING: "Carregando...",
        NOT_FOUND: "Reclamação ou token inválido/expirado.",
        PROTOCOL_NUMBER: "Número do Protocolo:",
        SECURE_ACCESS: {
            TITLE: "Acesso Seguro Confirmado",
            TEXT: "Você está acessando este caso através de um link único e seguro enviado por e-mail. Este link é válido apenas para visualização e resposta desta reclamação específica.",
        },
        SECTIONS: {
            DETAILS: {
                TITLE: "Detalhes da Reclamação",
                CATEGORY: "Categoria",
                DESCRIPTION: "Descrição do problema",
                REGISTRATION_DATE: "Data de Registro",
            },
            CONSUMER: {
                TITLE: "Dados do Consumidor",
                FULL_NAME: "Nome Completo",
                RG: "RG",
                CPF: "CPF",
                EMAIL: "E-mail",
                PHONE: "Telefone",
                CEP: "CEP",
                ADDRESS: "Endereço",
            },
            SUPPLIER: {
                TITLE: "Dados da empresa",
                NAME: "Nome",
                COMPANY_NAME: "Razão social",
                CNPJ: "CNPJ",
                EMAIL: "E-mail",
                PHONE: "Telefone",
                CEP: "CEP",
                ADDRESS: "Endereço completo",
            },
            REPLY: {
                TITLE: "Enviar Resposta",
                INSTRUCTIONS: "Apresente sua proposta de acordo para esta reclamação para resolver a questão com o consumidor. Sua resposta será analisada pela equipe do Procon-PE.",
                ATTENTION_TITLE: "Atenção",
                ATTENTION_TEXT: "Sua resposta será compartilhada com o consumidor e com a equipe do Procon-PE. Certifique-se de fornecer informações precisas e completas.",
                REPLY_LABEL: "Sua resposta*",
                REPLY_PLACEHOLDER: "Apresente uma proposta de solução amigável para resolver a questão com o consumidor.",
                REPLY_HINT: function (count) { return "M\u00EDnimo de 50 caracteres (".concat(count, "/50)"); },
                DOCUMENTS_LABEL: "Documentos Adicionais",
                DOCUMENTS_NOTE: "Formatos aceitos: JPG, PNG, PDF. Tamanho máximo: 10MB por arquivo. Máximo: 5 arquivos.",
                SUBMIT: "Enviar resposta",
                SUBMITTING: "Enviando...",
                LGPD_WARNING: "Ao enviar esta resposta, você declara que as informações fornecidas são verdadeiras e está ciente de que documentos falsos podem resultar em penalidades legais. Seus dados serão tratados conforme a LGPD.",
            },
            ATTACHMENTS: {
                TITLE: "Anexos",
                DOWNLOAD: "Baixar",
                DOWNLOAD_ALL: "Baixar todos os anexos (ZIP)",
            },
            STATUS: {
                TITLE: "Status da reclamação",
                DESCRIPTION: "Aguardamos sua manifestação sobre esta reclamação.",
                CURRENT_STATUS: "Status atual",
            },
            HISTORY: {
                TITLE: "Histórico",
            },
        },
    },
    // ─── Layout Cidadão ──────────────────────────────────────────────────────────
    CITIZEN_LAYOUT: {
        SIDEBAR_TITLE: "Procon PE",
        VERSION: "1.0.0",
        DEFAULT_NAME: "Cidadão",
        PROFILE: "Cidadão",
        MENU: {
            HOME: "Início",
            MY_CASES: "Meus Casos",
            FAQ: "Dúvidas Frequentes",
        },
        USER_ACTIONS: {
            PROFILE: "Perfil",
            LOGOUT: "Sair",
        },
        BREADCRUMB: {
            HOME: "Início",
            RECLAMATION: "Reclamação",
            FORM_TITLE: "Registro de Reclamação",
        },
        MY_CASES: {
            TITLE: "Meus Casos",
            DESCRIPTION: "Acompanhe o status e o histórico de todas as suas solicitações.",
            EMPTY: {
                TITLE: "Você ainda não possui nenhum caso registrado.",
                BUTTON: "Iniciar nova Reclamação",
            },
            LIST: {
                PROTOCOL_LABEL: "Número de Protocolo",
                TYPE_LABEL: "Tipo",
                SUPPLIER_LABEL: "Empresa",
                STATUS_LABEL: "Status Atual",
                DATE_LABEL: "Data de Registro",
            },
            TYPES: {
                RECLAMATION: "Reclamação",
                COMPLAINT: "Denúncia",
            },
            STATUS: {
                RECEIVED: "Recebido",
                IN_ANALYSIS: "Em Análise",
                IN_INSPECTION: "Em Fiscalização",
                COMPLETED: "Concluído",
                ARCHIVED: "Arquivado",
            },
        },
    },
    EMPLOYEE_MANAGEMENT: {
        TITLE: "Gestão de Funcionários",
        DESCRIPTION: "Gerencie os perfis de técnicos e atendentes do sistema.",
        NEW_EMPLOYEE_BUTTON: "Novo Funcionário",
        CREATE_MODAL: {
            TITLE: "Cadastrar Novo Funcionário",
            SUBTITLE: "Preencha os dados abaixo para enviar o convite de acesso.",
            SUCCESS_TOAST: "Funcionário cadastrado e convite enviado!",
        },
        LIST: {
            EMPTY: "Nenhum funcionário encontrado.",
            ROLE_LABEL: "Cargo",
            STATUS_LABEL: "Status",
            ACTIONS_LABEL: "Ações",
            RESEND_INVITATION: "Reenviar Convite",
            INACTIVATE: "Inativar",
            ACTIVATE: "Ativar",
            RESEND_SUCCESS: "Convite reenviado com sucesso!",
            STATUS_SUCCESS: "Status atualizado com sucesso!",
        },
        ROLES: {
            ADMIN: "Administrador",
            OVERSIGHT_TECHNICIAN: "Técnico de Fiscalização",
            SERVICE_TECHNICIAN: "Técnico de Atendimento",
        },
        STATUS: {
            ACTIVE: "Ativo",
            INACTIVE: "Inativo",
        },
        FIELDS: {
            NAME: "Nome Completo",
            EMAIL: "E-mail",
            CPF: "CPF",
            RG: "RG",
            PHONE: "Telefone",
            BIRTH_DATE: "Data de Nascimento",
            MATRICULA: "Matrícula",
            DEPARTAMENTO: "Departamento",
        },
    },
    ACCOUNT_ACTIVATION: {
        TITLE: "Ative sua conta",
        SUBTITLE: "Defina uma senha segura para acessar o sistema Procon-PE.",
        PASSWORD_LABEL: "Nova Senha",
        CONFIRM_PASSWORD_LABEL: "Confirmar Senha",
        SUBMIT_BUTTON: "Ativar Conta",
        SUCCESS_TITLE: "Conta Ativada!",
        SUCCESS_MESSAGE: "Sua conta foi ativada com sucesso. Você será redirecionado para o login.",
        VALIDATION: {
            MIN_LENGTH: "Pelo menos 8 caracteres",
            UPPERCASE: "Pelo menos uma letra maiúscula",
            LOWERCASE: "Pelo menos uma letra minúscula",
            NUMBER: "Pelo menos um número",
            SPECIAL: "Pelo menos um caractere especial (!@#$%^&*)",
            MATCH: "As senhas não coincidem",
        },
    },
};
